import type { Dispatch } from 'react';
import { SectionCard } from '../../anketa/components/SectionCard';
import { SectionHeader } from '../../anketa/components/SectionHeader';
import type { QuoteAction } from '../quoteReducer';
import type { QuoteState } from '../types';

/**
 * PR-H4 — раздел «Название компании / Имя» исполнителя.
 *
 * Рендерится первой секцией КП (выше «Тип мебели») по требованию Aibek
 * 2026-05-28. Значение также отображается в верхнем левом углу PDF
 * (см. `renderQuoteToPdf.drawCompanyTopLeft` — переписан в PR-H6 / ADR-0029
 * с navy header → white background + black italic 14pt). Optional поле —
 * пустое значение допустимо и означает «без бренда исполнителя» в PDF
 * (top-left пропускается).
 *
 * Pattern по образцу SectionComments — single-input section без validation.
 *
 * Length cap: maxLength=50 chars — defensive constraint против overflow в PDF
 * top-left (14pt italic @ x=marginX=12mm; pageW=210mm → centered title @ x=105mm
 * оставляет ~80mm горизонтального пространства). Реальные company names обычно
 * <40 chars; 50 — comfortable cap.
 */
export interface SectionCompanyNameProps {
  state: QuoteState;
  dispatch: Dispatch<QuoteAction>;
}

export function SectionCompanyName({ state, dispatch }: SectionCompanyNameProps) {
  return (
    <SectionCard testId="section-company-name">
      <SectionHeader>Название компании / Имя</SectionHeader>
      <input
        id="quote-company-name-input"
        type="text"
        value={state.companyName ?? ''}
        onChange={(e) => dispatch({ type: 'SET_COMPANY_NAME', value: e.target.value })}
        maxLength={50}
        aria-label="Название компании"
        data-testid="company-name-input"
        placeholder="Например, ЛучшаяМебель"
        className="w-full min-h-tap px-3 rounded-xl border-[1.5px] border-accent bg-card text-base text-ink focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none"
      />
    </SectionCard>
  );
}
